enum DataTableColorizationMode {
  COLORED_CELLS = 'colored-cells',
  COLORED_ROWS = 'colored-rows',
  EVEN_ODD = 'even-odd',
  NO = 'no',
}

export default DataTableColorizationMode;
